/**
 * The entry point for the admin side wp-admin resource.
 */ import { jsx as _jsx } from "react/jsx-runtime";
import "@devowl-wp/utils/antd.scss";
import "./style/admin.scss";
import $ from "jquery";
import { createRoot } from "react-dom/client";
import { handleCorruptRestApi } from "@devowl-wp/utils";
import { Provider } from "./components/common/provider.js";
import { AppTree } from "./components/tree/appTree.js";
import { addSwitchToListTable } from "./others/addSwitchToListTable.js";
import { RootStore } from "./store/rootStore.js";
import { request } from "./utils/request.js";
handleCorruptRestApi({
    [RootStore.get.optionStore.restNamespace]: async ()=>{
        await request({
            location: {
                path: "/plugin"
            }
        });
    }
});
$(document).ready(async ()=>{
    const { optionStore: { others } } = RootStore.get;
    const { typenow, screenSettings: { isActive } } = others;
    // Compatibility with Elementor "Popup" cause it listens to the first "Add new" button
    if (process.env.PLUGIN_CTX === "pro") {
    /* Silence is golden... Until you have PRO Version! */ }
    // Avoid flickering
    $("#wpbody").fadeTo(100, 1);
    if (isActive) {
        $("body").addClass("activate-aiot");
        const container = $("<div/>").prependTo("body.wp-admin #wpbody").addClass("rcl-container").get(0);
        createRoot(container).render(/*#__PURE__*/ _jsx(Provider, {
            children: /*#__PURE__*/ _jsx(AppTree, {})
        }));
    } else {
        addSwitchToListTable();
    }
});
$("link#dark_mode-css").length && $("body").addClass("aiot-wp-dark-mode");
// Expose this functionalities to add-ons, but you need to activate the library functionality
// in your webpack configuration, see also https://webpack.js.org/guides/author-libraries/
export * from "@devowl-wp/utils";
export * from "./wp-api/index.js";
export * from "./store/index.js";
